import { render } from "./ModalCambiarPassword.vue?vue&type=template&id=33c3b2ad&scoped=true"
import script from "./ModalCambiarPassword.vue?vue&type=script&lang=js"
export * from "./ModalCambiarPassword.vue?vue&type=script&lang=js"

import "./ModalCambiarPassword.vue?vue&type=style&index=0&id=33c3b2ad&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c3b2ad"]])

export default __exports__